import React from "react";
import {
  PieChart,
  Pie,
  Legend,
  Tooltip,
  Cell,
  ResponsiveContainer,
} from "recharts";
import PropTypes from "prop-types";

// const data01 = [
//   { name: 'Project', value: 411 },
//   { name: 'Transactional', value: 357 },
//   { name: 'Non Transactional', value: 47 }
// ]

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  index,
}) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      dominantBaseline="central"
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

function CustomPieChartWithHeader(props) {
  const { width, height, colors, data, isLegendRequired } = props;

  const renderColorfulLegendText = (value, entry) => {
    const { color } = entry;

    return (
      <span style={{ color, marginLeft: 5, marginRight: 5 }}>{value}</span>
    );
  };
  return (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart width={400} height={400}>
        <Pie
          data={data}
          dataKey="value"
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderCustomizedLabel}
          outerRadius={125}
          fill="#8884d8"
        >
          {data.map((entry, index) => (
            <Cell key={index} fill={colors[entry.name]} />
          ))}
        </Pie>
        <Tooltip />
        {isLegendRequired && (
          <Legend
            iconType="square"
            iconSize={20}
            height={50}
            // formatter={renderColorfulLegendText}
            width="100%"
            verticalAlign="top"
            align="center"
          />
        )}
      </PieChart>
    </ResponsiveContainer>
  );
}

CustomPieChartWithHeader.propTypes = {
  data: PropTypes.array.isRequired,
  isLegendRequired: PropTypes.bool.isRequired,
};

export default CustomPieChartWithHeader;
